import { AlertTriangle, CheckCircle2, XOctagon } from "lucide-react";

/**
 * GovSchemeBadge — Status pill for a government cashless appointment.
 *
 * States:
 *   - `pending_counter_verification` + gov_verified=false → flashing red
 *     "Card Not Verified" (attention grab for the receptionist).
 *   - gov_verified=true → green "Verified & Active".
 *   - gov_verification_rejected=true → grey "Card Rejected".
 *   - Any non-gov row → returns null.
 */
export default function GovSchemeBadge({ appointment }) {
  const method = (appointment?.payment_method || "").toLowerCase();
  if (method !== "rghs" && method !== "ayushman") return null;

  const scheme = method.toUpperCase();

  if (appointment.gov_verification_rejected) {
    return (
      <span
        className="inline-flex items-center gap-1 rounded-full bg-slate-200 text-slate-700 text-[10px] font-semibold px-2 py-0.5"
        data-testid={`gov-badge-rejected-${appointment.id}`}
      >
        <XOctagon size={11} /> {scheme} Card Rejected
      </span>
    );
  }

  if (appointment.gov_verified) {
    return (
      <span
        className="inline-flex items-center gap-1 rounded-full bg-emerald-100 text-emerald-700 text-[10px] font-semibold px-2 py-0.5"
        data-testid={`gov-badge-verified-${appointment.id}`}
      >
        <CheckCircle2 size={11} /> {scheme} Verified &amp; Active
      </span>
    );
  }

  // Unverified — flash to grab receptionist attention.
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full bg-rose-100 text-rose-700 text-[10px] font-semibold px-2 py-0.5 animate-pulse ring-1 ring-rose-300"
      data-testid={`gov-badge-unverified-${appointment.id}`}
    >
      <AlertTriangle size={11} /> {scheme} Card Not Verified
    </span>
  );
}
